import { api } from './networkService';

class RoleService {
    static async fetchPermissions() {
        try {
            const response = await api.get(`api/user/user/permissions`);
            return response.data;
        } catch (error) {
            console.error('Fetch role error:', error);
            throw error;
        }
    }

    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/user/role`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch role error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/user/role`);
            return response.data;
        } catch (error) {
            console.error('Fetch role error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/user/role/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch role error:', error);
            throw error;
        }
    }

    static async add(role) {
        try {
            const cleanedRole = Object.fromEntries(
                Object.entries(role).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/user/role`, cleanedRole);
            return response;
        } catch (error) {
            console.error('Add role error:', error);
            throw error;
        }
    }

    static async update(role) {
        try {
            const { id, ...info } = role;
            const cleanedRole = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/user/role/${id}`, cleanedRole);
            return response;
        } catch (error) {
            console.error('Update role error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/user/role/${id}`);
            return response;
        } catch (error) {
            console.error('Delete role error:', error);
            throw error;
        }
    }
}

export default RoleService;
